import React, { Component } from 'react';
import { Alert, Col, Form, FormControl, FormGroup, ControlLabel, HelpBlock, Button, Modal } from 'react-bootstrap';
import rest from 'rest';

import { REST_API_URL } from "../../Utils/Global";
import { csvToArray } from "../../Utils/Utils";

import FileUpload from './FileUpload';
import Grid from './Grid';
import MapModal from './MapModal';

/**
* Class GeometryGrid
* Generic component to generate geom grids
**/
class GeometryGrid extends Component {

  /**
  * constructor
  * Init state
  **/
  constructor(props) {
    super(props);

    this.state = {
      mapFrame: false,
      csvFrame: false,
      csvMessage: {},
      hidden: true
    };

    this.receiveMessage = this.receiveMessage.bind(this);
  }

  /**
  * componentWillMount
  * Init window event to get IFrame response
  **/
  componentWillMount() {
    addEventListener("message", this.receiveMessage);
  }

  /**
  * componentWillUnmount
  * Delete window event
  **/
  componentWillUnmount() {
    removeEventListener("message", this.receiveMessage);
  }

  /**
  * receiveMessage
  * Handle IFrame response
  **/
  receiveMessage(event) {
    this.state = {
      mapFrame: false
    };

    this.processImport(event.data);
  }

  /**
  * processImport
  * process data import
  **/
  processImport(data) {

    if(!(data instanceof Array) || data.length === 0) return;

    data.forEach(function(geom) {
      if(!(geom.geojson instanceof Object)) geom.geojson = null;
      else {
        geom.geojson.crs = {
          type: "name",
          properties: {
            name: "EPSG:3857"
          }
        };
      }
    });

    console.log(data);
    rest({
      method: "POST",
      path: REST_API_URL + this.props.objectPath,
      entity: JSON.stringify(data),
      headers: {'Content-Type': 'application/json'}
    }).then(response => {
      if(response.status.code === 201) {
        let objects = JSON.parse(response.entity);
        let state = this.state;

        state.objects = objects;
        state.hidden = false;
        state.status = {
          type: 'success',
          message: 'Géométrie(s) créée(s).'
        };

        this.setState(state);
        this.refs.grid.reload();
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
    }, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
    });
  }

  /**
  * render
  * Render the component : grid, modal carto, buttons
  **/
  render() {
    let gridProps = {...this.props};
    gridProps.title = "";
    gridProps.hidden = this.state.hidden;

    return(
      <div className="geomGrid">

        {this.getSelectMapModal()}
        {this.getCsvModal()}

        <h4 className="gridTitle" onClick={this.showGrid.bind(this)}>
          {this.props.title}
          <span className={"glyphicon glyphicon-chevron-" + (this.state.hidden === false ? "down" : "right")}></span>
        </h4>
        {(this.props.mode === "edit" && this.state.hidden === false) &&
            <div className="geomButtons">
              <FormGroup>
                  <Col sm={3}><Button bsStyle="primary" onClick={this.openMapFrame.bind(this)}>Sélectionner la géométrie sur la carte</Button></Col>
                  {this.props.withImportCsv === true &&
                    <Col sm={2}><Button bsStyle="primary" onClick={this.openCsvFrame.bind(this)}>Importer un fichier csv de coordonnées</Button></Col>
                  }


              </FormGroup>
              {/* <FormGroup>
                {this.props.withImportPoint === true &&
                  <div>
                    <Col sm={2}><ControlLabel>Import de point</ControlLabel></Col>
                    <Col sm={2}><FormControl id="importPointX" className="inputCoord" type="text" placeholder="X" onChange={this.handleCoordChange.bind(this)} /></Col>
                    <Col sm={2}><FormControl id="importPointY" className="inputCoord" type="text" placeholder="Y" onChange={this.handleCoordChange.bind(this)} /></Col>
                    <Col sm={2}><Button bsStyle="primary" onClick={this.importPoint.bind(this)}>Importer</Button></Col>
                  </div>
                }
              </FormGroup> */}

            </div>
        }
        {(this.state.hidden === false) ? <Grid ref="grid" {...gridProps} ignoreAdd={true} isGeom={true}/> : null}
      </div>
    );
  }

  /**
  * showGrid
  * Manage grid visilibity
  **/
  showGrid() {
    let state = this.state;
    state.hidden = !state.hidden;
    this.setState(state);
  }

  /**
  * handleCoordChange
  * Modify the state from a field change
  **/
  handleCoordChange(e) {
    let objState = this.state;
    const value = parseFloat(e.target.value);

    objState[e.target.id] = !isNaN(value) ? value : null;
    this.setState(objState);
  }

  /**
  * importPoint
  * Point import
  **/
  importPoint() {
    if(this.state.importPointX && this.state.importPointY) {
      const data = {
        geojson: {
          coordinates: [this.state.importPointX, this.state.importPointY],
          type: "Point"
        },
        layer: "point",
        shapeFile: null
      };

      this.processImport([data]);
    }
  }

  /**
  * getSelectMapModal
  * Map selection Modal
  **/
  getSelectMapModal() {
    console.log("getSelectMapModal");

    const mapProps = {
      mapFrame: this.state.mapFrame,
      onHide: this.handleMapCancel.bind(this),
      queryLayers: this.props.queryLayers,
      allowDraw: this.props.allowDraw,
      selectionMultiple: this.props.selectionMultiple,
      typeGeometry: this.props.typeGeometry
    };

    console.log(mapProps);
    return <MapModal {...mapProps} />;
  }

  /**
  * getCsvModal
  * Csv import Modal
  **/
  getCsvModal() {
    return(
      <Modal show={this.state.csvFrame} onHide={this.handleCsvCancel.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>Import de csv</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form horizontal>
            <HelpBlock>
              Le fichier doit comporter 2 colonnes X et Y.
              Les points seront aggrégés en MultiPoint.
            </HelpBlock>
            <FormGroup controlId="file">
              <Col componentClass={ControlLabel} sm={2}>Fichier</Col>
              <Col sm={6}>
                <FileUpload ref="file" accept=".csv" onChange={this.onCsvChange.bind(this)} />
              </Col>
            </FormGroup>
            {this.state.csvMessage!== undefined && this.state.csvMessage.value &&
              <FormGroup controlId="alert">
                <Col smOffset={2} sm={9}>
                  <Alert bsStyle={this.state.csvMessage.className}>
                    {this.state.csvMessage.value}
                  </Alert>
                </Col>
              </FormGroup>
            }
            {this.state.csvMessage!== undefined && this.state.csvMessage.className !== "danger" && this.state.csvValue &&
              <FormGroup>
                <Col smOffset={9} sm={1}>
                  <Button bsStyle="success" onClick={this.importCsv.bind(this)}>Importer</Button>
                </Col>
              </FormGroup>
            }
          </Form>
        </Modal.Body>
      </Modal>
    );
  }

  /**
  * onCsvChange
  * Handle CSV file change
  **/
  onCsvChange(fileField, file) {
    const thisRef = this;
    const fileReader = new FileReader();

    fileReader.onload = function() {
      const result = event.target.result;
      let csvArray = csvToArray(result);

      if(!Array.isArray(csvArray)) {
        thisRef.setState({
          csvMessage: {
            value: "Le fichier doit être au format CSV, délimité par des points-virgule.",
            className: "danger"
          },
          csvValue: undefined
        });
        return;
      }

      const header = csvArray.shift();
      if(!Array.isArray(header) || header[0].trim().toLowerCase() !== "x" || header[1].trim().toLowerCase() !== "y") {
        thisRef.setState({
          csvMessage: {
            value: "Le fichier CSV est mal formé.",
            className: "danger"
          },
          csvValue: undefined
        });
        return;
      }

      let values = [];
      csvArray.forEach(function(point) {
        if(Array.isArray(point) && point.length >= 2) {
          const x = parseFloat(point[0].trim());
          const y = parseFloat(point[1].trim());

          if(!isNaN(x) && !isNaN(y)) {
            values.push([x, y]);
          }
        }
      });

      if(values.length > 0) {
        const data = {
          geojson: {
            coordinates: values,
            type: "MultiPoint"
          },
          layer: "csv",
          shapeFile: file.name
        };

        thisRef.setState({
          csvMessage: {
            value: values.length + " point(s) détecté(s).",
            className: "info"
          },
          csvValue: [data]
        });
      } else {
        thisRef.setState({
          csvMessage: {
            value: "Aucun point à importer.",
            className: "danger"
          },
          csvValue: undefined
        });
      }
    }

    fileReader.readAsText(file);
  }

  /**
  * importCsv
  * Handle CSV file import
  **/
  importCsv() {
    const data = this.state.csvValue;

    this.state = {
      csvFrame: false
    };

    this.processImport(data);
  }

  /**
  * openMapFrame
  * Set the state to open modal with carto frame
  **/
  openMapFrame() {
    this.setState({mapFrame: true});
  }

  /**
  * handleMapCancel
  * Handle cancel click
  **/
  handleMapCancel() {
    this.setState({mapFrame: false});
  }

  /**
  * openCsvFrame
  * Set the state to open modal with carto frame
  **/
  openCsvFrame() {
    this.setState({csvFrame: true});
  }

  /**
  * handleCsvCancel
  * Handle cancel click
  **/
  handleCsvCancel() {
    this.setState({csvFrame: false});
  }

}

export default GeometryGrid;



// WEBPACK FOOTER //
// ./src/views/Helper/GeometryGrid.js